module.exports = __webpack_public_path__ + "static/media/ball_5_1.f4c23795.mp3";